<div class="container contact">
    <div class="row justify-content-center gy-5">
        <div class="col-lg-6 col-xl-5">
            <div class="contact-card">
                <div class="contact-head">
                    <h6 class="contact-eyebrow">Get in Touch</h6>
                    <h2 class="contact-title">Let’s Discuss Projects</h2>
                    <p class="contact-sub">Get in touch with me for any kind of help.</p>
                </div>

                <ul class="contact-list">
                    <!-- <li class="contact-item">
            <a class="contact-link" href="tel:+38345900012" aria-label="Call Donart">
              <span class="contact-icon">
                <i class="fas fa-phone-alt"></i>
              </span>
              <span class="contact-body">
                <span class="contact-label">Phone</span>
                <span class="contact-value">+383 (45) 900 012</span>
              </span>
              <span class="contact-cta">
                <i class="bi bi-arrow-right"></i>
              </span>
            </a>
          </li> -->

                    <li class="contact-item" style="cursor: pointer !important;">
                        <a class="contact-link" href="mailto:donart.pllashniku@gmail.com" aria-label="Email Donart">
                            <span class="contact-icon">
                                <i class="fas fa-envelope"></i>
                            </span>
                            <span class="contact-body">
                                <span class="contact-label">Mail</span>
                                <span class="contact-value">donart.pllashniku@gmail.com</span>
                                <span class="contact-value contact-value--muted">dp@trioxk.com</span>
                            </span>
                            <span class="contact-cta">
                                <i class="bi bi-arrow-right"></i>
                            </span>
                        </a>
                    </li>
                    <li class="contact-item" style="cursor: pointer !important;">
                        <a class="contact-link"
                            href="https://wa.me/491639159766?text=Hi%20Donart%2C%20I%20would%20like%20to%20discuss%20a%20project."
                            target="_blank" rel="noopener" aria-label="Chat on WhatsApp">
                            <span class="contact-icon contact-icon--wa">
                                <i class="fab fa-whatsapp"></i>
                            </span>
                            <span class="contact-body">
                                <span class="contact-label">WhatsApp</span>
                                <span class="contact-value">Chat directly</span>
                            </span>
                            <span class="contact-cta">
                                <i class="bi bi-arrow-up-right"></i>
                            </span>
                        </a>
                    </li>

                    <li class="contact-item">
                        <div class="contact-link contact-link--static">
                            <span class="contact-icon">
                                <i class="fas fa-map-marker-alt"></i>
                            </span>
                            <span class="contact-body">
                                <span class="contact-label">Visit Me</span>
                                <span class="contact-value">10000 Prishtina</span>
                            </span>
                            <span class="contact-cta">
                                <i class="bi bi-geo-alt"></i>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>